import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import medal from '@assets/medal_white.svg';
import * as Styled from './styled';

export const ModalSpecializedBanner: FC = () => {
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      <img src={medal} alt="icon" width={16} />
      {translate('common.modals.specializedSite')}
    </Styled.Wrapper>
  );
};
